import { useState } from "react";
import {
    useStripe,
    useElements,
    PaymentElement,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";

export default function StripeCheckoutForm({ orderId, shipmentId }) {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const buildSuccessUrl = (paymentIntentId = "") => {
        const params = new URLSearchParams();

        if (paymentIntentId) params.set("payment_intent", paymentIntentId);
        if (orderId) params.set("orderId", orderId);
        if (shipmentId) params.set("shipmentId", shipmentId);

        return `/payment-success?${params.toString()}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) return;

        setLoading(true);
        setErrorMessage("");

        const returnUrl = `${window.location.origin}${buildSuccessUrl()}`;

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: returnUrl,
            },
            redirect: "if_required",
        });

        if (result.error) {
            setErrorMessage(result.error.message || "Payment failed");
            setLoading(false);
            return;
        }

        if (result.paymentIntent?.status === "succeeded") {
            navigate(buildSuccessUrl(result.paymentIntent.id));
            return;
        }

        setLoading(false);
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="max-w-md mx-auto p-4 border rounded bg-white"
        >
            <h2 className="text-lg font-bold mb-3">Payment</h2>

            <PaymentElement />

            <button
                type="submit"
                disabled={!stripe || loading}
                className="mt-4 w-full bg-blue-600 text-white py-2 rounded"
            >
                {loading ? "Processing..." : "Pay"}
            </button>

            {errorMessage && (
                <p className="mt-3 text-red-600 text-sm">
                    {errorMessage}
                </p>
            )}
        </form>
    );
}